exports.payment_info = {
  contactPhone: '+7(909)579-24-28', // телефон
  direktor: '----------', // директор
  corporateAccount: '30101810500000000653', // корресподентский счёт
  bik: '044030653', // БИК
  bankName: 'ПАО «Сбербанк»', // банк
  checkingAccount: '40702810655000021986', // расчётный счёт
  ogrn: '1204700014530', // ОГРН
  kpp: '470301001', // КПП
  inn: '4703177344', // ИНН
  shortInternationName: 'Urikoff LLC', // сокращено (интернациональное название)
  internationName: 'Urikoff Limited Liability Company', // Английское
  shortName: 'ООО «Юрикофф»', // Сокращенно
  fullName: 'Общество с ограниченной ответственностью «Юрикофф»' // Наименование
}
exports.uslugi = [
  // { text: 'Написание искового заявления', price: 'от 2 000 руб.' },
  // { text: 'Написание апелляционной (кассационной, надзорной) жалобы', price: 'от 3 000 руб.' },
  // { text: 'Написание претензии', price: 'от 1 000 руб.' },
  // { text: 'Составление договора', price: 'от 3 000 руб.' },
  // { text: 'Правовой аудит документов', price: 'от 1 000 руб. за документ' },
  // { text: 'Составление протокола разногласий', price: 'от 2 000 руб.' },
  // { text: 'Сопровождение процедуры банкротства', price: 'от 10 000 руб.' },
  // { text: 'Сопровождение сделок с недвижимостью', price: 'от 30 000 руб.' },
  // { text: 'Лицензирование', price: 'от 20 000 руб.' },
  // { text: 'Консультирование', price: 'от 1 000 руб.' },
  // { text: 'Подготовка письменного заключения', price: 'от 3 000 руб.' }
]



// WEBPACK FOOTER //
// ./src/data/requisites.js